import { useState } from "react";

import GroupButtons from "../../../../../../../Components/GroupButtons/GroupButtons";
import CustomReason from "./Components/CustomReason";
import MuteManager from "./Components/MuteManager";
import PredefinedReason from "./Components/PredefinedReason/PredefinedReason";
import { AddToastNotification } from "../../../../../../../Services/ToastNotification/ToastNotificationManager";

import PlayerRequests from "../../../../../../../Services/Api/PlayerRequests.ts";
import ServerRequests from "../../../../../../../Services/Api/ServersRequests.ts";

import "./Moderation.css";

const Moderation = ({serverId, getPlayerIds, getOnlinePlayers, getOfflinePlayers}) => {
    const serverRequests = new ServerRequests();
    const playerRequests = new PlayerRequests();

    const [selected, setSelected] = useState(0);

    const ban = (time, reason, onSuccess) => {
        const playerIds = getPlayerIds();

        if(playerIds.length > 0)
        {
            serverRequests.ExecuteCommand(serverId, `/ban ${playerIds} ${time} ${reason}`, () => {
                AddToastNotification("Polecenie wysłane do wykonania!", 1);
                onSuccess();
            });
        }

        const offlinePlayers = getOfflinePlayers();

        if(offlinePlayers.length > 0){
            playerRequests.BanOfflinePlayers(serverId, time, offlinePlayers, reason, () => {
                AddToastNotification(`Zbanowano ${offlinePlayers.length} graczy offline!`, 1);
                onSuccess();
            })
        }
    }

    return (
        <>
            <h3 className="text-center mb-3">Select player(s) from list, then choose ban duration and confirm your decision</h3>
            <GroupButtons
                    buttons={[
                        { text: "PREDEFINED REASONS" }, 
                        { text: "CUSTOM REASON" }, 
                        { text: "MUTE MANAGER" }, 
                    ]}
                selected={selected}
                setSelected={setSelected}
            />
            { selected == 0 &&
                <PredefinedReason getOnlinePlayers={getOnlinePlayers} getOfflinePlayers={getOfflinePlayers} executeBan={ban}/>
            }
            { selected == 1 &&
                <CustomReason executeBan={ban} getOnlinePlayers={getOnlinePlayers} getOfflinePlayers={getOfflinePlayers}/>
            }   
            { selected == 2 &&
                <MuteManager serverId={serverId} getPlayerIds={getPlayerIds}/>
            }        
        </>
    )
}

export default Moderation;